/*
    Refactor
*/

import { GLOBAL_VARIABLES } from './config'
import { loadScript } from './utilities/loadScript'
import { pixelVisitaF } from './utilities/pixelVisitaF'
import { showInactivityModal } from './utilities/showInactivityModal'
import { horario } from './utilities/horario'
import { folderJSpath } from './utilities/folderJSpath'
import { loadInbounds } from './utilities/loadInbounds'
import { loadAllLibs } from './utilities/loadAllLibs';

console.log('hola estamos ejecutando el script padre')



const { DAL, DRP, DCL, swiper, jquery, jqueryUi, bootstrap, walmeric, merkleJsFile } = GLOBAL_VARIABLES.libraries
const { priorityIVR } = GLOBAL_VARIABLES


const loadLibrariesFront = async () => {
  try {
    const localHost = globalThis.location.hostname;
    if (localHost != "localhost") {
      await loadAllLibs([jquery, jqueryUi, swiper, bootstrap, merkleJsFile, walmeric]);
    } else {
      await loadAllLibs([jquery, jqueryUi, swiper, bootstrap]);
    }
  } catch (error) {
    console.error("error en loadLibrariesFront", error);
  }
}

const loadLibrariesWalmeric = () => {
  try {
    loadAllLibs([DAL, DRP, DCL, priorityIVR])
      .then(() => {
        pixelVisitaF();
      })
      .then(() => {
        loadInbounds();
        window.DRP.loadLabels(window.userLabels)
      });
  } catch (error) {
    console.error("error en loadLibrariesWalmeric", error);
  }
}

loadLibrariesFront();
loadLibrariesWalmeric();


/**
 * Establecer el origen especial para el ringpool. No deja actualizar las etiquetas desde el script de landing.
 */
let urlData = new URL(window.location.href);
let origen_data = urlData.searchParams.get("origen");

if (origen_data != null && origen_data != undefined && origen_data != "undefined") {
  window.c_var_26 = origen_data;
}

// Carga de modal de inactividad - segundos
showInactivityModal('30')

window.horario = horario();

window.clientConfig = {
  timeoutTooltip: 3,
  lang: 'es',
  pos: 'bottom',
  sendHidden: true,
  type: 'tooltip',
  validate: true,
  validation: {
    notification: {
      type: 'tooltip'
    }
  }
}